// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-two-panel-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
.reports-two-panel-layout .reports-panel-full {
  width: 100%;
  max-width: 100%;
}

.reports-generate-section .reports-action-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}
.reports-generate-section .reports-toggle-query-button {
  height: 41px;
  background-color: #ECF6FF;
  border: 1px solid #E0E6EB;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  transition: all 0.2s ease;
  gap: 8px;
}
.reports-generate-section .reports-toggle-query-button:hover {
  background-color: #E0F2FF;
}
.reports-generate-section .reports-toggle-query-button .reports-toggle-text {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #40A0C1;
}
.reports-generate-section .reports-generate-button {
  flex: 1 1;
  height: 41px;
  background-color: #ECF6FF;
  border: 1px solid #E0E6EB;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 28px;
  transition: all 0.2s ease;
}
.reports-generate-section .reports-generate-button:hover {
  background-color: #E0F2FF;
}
.reports-generate-section .reports-generate-button .reports-generate-text {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #40A0C1;
  margin-right: 8px;
}

.reports-search-bar {
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
}
.reports-search-bar .reports-search-input-wrapper {
  border: 1px solid #6A8991;
  padding: 3px;
  border-radius: 10px;
  width: 310px;
}
.reports-search-bar .reports-search-input-wrapper .reports-search-input {
  resize: none;
  background-color: transparent;
  font-size: 16px;
  color: #6A8991;
  outline: none;
  padding: 3px;
  border: 0;
  width: 300px;
}
.reports-search-bar .reports-search-file-input {
  background-color: #40A0C1;
  font-size: 18px;
  outline: none;
  padding: 7px 12px;
  border-radius: 20px;
  border: 0;
  color: white;
  cursor: pointer;
  white-space: nowrap;
}
.reports-search-bar .reports-search-file-input:hover {
  opacity: 0.95;
}
.reports-search-bar .reports-search-file-name {
  padding: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-search-bar .reports-radio-row {
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  font-weight: 500;
  color: #142A31;
  padding-top: 4px;
}
.reports-search-bar .reports-radio-title {
  font-size: 14px;
  font-weight: 500;
  color: #6A8991;
}
.reports-search-bar .reports-search-method-row {
  display: grid;
  grid-template-columns: 350px 120px 1fr;
  align-items: center;
  height: 60px;
}
.reports-search-bar .reports-go-button {
  cursor: pointer;
}
.reports-search-bar .reports-go-button:hover {
  opacity: 0.95;
}
.reports-search-bar .reports-query-container {
  display: grid;
  row-gap: 10px;
}
.reports-search-bar .reports-query-container .reports-query-logic {
  padding: 0 15px;
  margin-right: 10px;
  -webkit-user-select: none;
          user-select: none;
  background-color: #6A8991;
  border-radius: 45px;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reports-search-bar .reports-query-button {
  background-color: #40A0C1;
  font-size: 16px;
  outline: none;
  padding: 6px 16px;
  border-radius: 6px;
  border: 0;
  color: white;
  cursor: pointer;
  white-space: nowrap;
}
.reports-search-bar .reports-search-title {
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 15px;
}
.reports-search-bar .reports-info-box {
  background-color: #C9EBF6;
  padding: 8px 18px 8px 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
.reports-search-bar .reports-methods {
  display: grid;
  grid-template-columns: 180px 1fr;
  height: 60px;
}
.reports-search-bar .reports-fields {
  display: grid;
  grid-template-columns: 180px 1fr;
}
.reports-search-bar .reports-search-bar-half {
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 10px;
}

.andOrButton {
  padding: 0 15px;
  margin-right: 10px;
  background-color: #6A8991;
  border-radius: 45px;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/Reports/Reports.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,0BAAA;EACA,SAAA;AACD;AACC;EACC,WAAA;EACA,eAAA;AACF;;AAIC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AADF;AAIC;EACC,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAFF;AAIE;EACC,yBAAA;AAFH;AAKE;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHH;AAOC;EACC,SAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;AALF;AAOE;EACC,yBAAA;AALH;AAQE;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AANH;;AAWA;EACC,sBAAA;EACA,uBAAA;EACA,aAAA;AARD;AAUC;EACC,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AARF;AAUE;EACC,YAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;AARH;AAYC;EACC,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAVF;AAaC;EACC,aAAA;AAXF;AAcC;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAZF;AAeC;EACC,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAbF;AAgBC;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AAdF;AAiBC;EACC,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;AAfF;AAkBC;EACC,eAAA;AAhBF;AAmBC;EACC,aAAA;AAjBF;AAoBC;EACC,aAAA;EACA,aAAA;AAlBF;AAoBE;EACC,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBH;AAsBC;EACC,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AApBF;AAuBC;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;AArBF;AAwBC;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AAtBF;AAyBC;EACC,aAAA;EACA,gCAAA;EACA,YAAA;AAvBF;AA0BC;EACC,aAAA;EACA,gCAAA;AAxBF;AA2BC;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AAzBF;;AA6BA;EACC,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA1BD","sourcesContent":[".reports-two-panel-layout {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr;\n\tgap: 20px;\n\n\t.reports-panel-full {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t}\n}\n\n.reports-generate-section {\n\t.reports-action-buttons {\n\t\tdisplay: flex;\n\t\tgap: 12px;\n\t\talign-items: center;\n\t}\n\n\t.reports-toggle-query-button {\n\t\theight: 41px;\n\t\tbackground-color: #ECF6FF;\n\t\tborder: 1px solid #E0E6EB;\n\t\tborder-radius: 4px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 0 20px;\n\t\ttransition: all 0.2s ease;\n\t\tgap: 8px;\n\n\t\t&:hover {\n\t\t\tbackground-color: #E0F2FF;\n\t\t}\n\n\t\t.reports-toggle-text {\n\t\t\tfont-family: 'Inter', sans-serif;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\tcolor: #40A0C1;\n\t\t}\n\t}\n\n\t.reports-generate-button {\n\t\tflex: 1;\n\t\theight: 41px;\n\t\tbackground-color: #ECF6FF;\n\t\tborder: 1px solid #E0E6EB;\n\t\tborder-radius: 4px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tpadding: 0 28px;\n\t\ttransition: all 0.2s ease;\n\n\t\t&:hover {\n\t\t\tbackground-color: #E0F2FF;\n\t\t}\n\n\t\t.reports-generate-text {\n\t\t\tfont-family: 'Inter', sans-serif;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\t\t\tcolor: #40A0C1;\n\t\t\tmargin-right: 8px;\n\t\t}\n\t}\n}\n\n.reports-search-bar {\n\tflex-direction: column;\n\talign-items: flex-start;\n\tpadding: 15px;\n\n\t.reports-search-input-wrapper {\n\t\tborder: 1px solid #6A8991;\n\t\tpadding: 3px;\n\t\tborder-radius: 10px;\n\t\twidth: 310px;\n\n\t\t.reports-search-input {\n\t\t\tresize: none;\n\t\t\tbackground-color: transparent;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #6A8991;\n\t\t\toutline: none;\n\t\t\tpadding: 3px;\n\t\t\tborder: 0;\n\t\t\twidth: 300px;\n\t\t}\n\t}\n\n\t.reports-search-file-input {\n\t\tbackground-color: #40A0C1;\n\t\tfont-size: 18px;\n\t\toutline: none;\n\t\tpadding: 7px 12px;\n\t\tborder-radius: 20px;\n\t\tborder: 0;\n\t\tcolor: white;\n\t\tcursor: pointer;\n\t\twhite-space: nowrap;\n\t}\n\n\t.reports-search-file-input:hover {\n\t\topacity: 0.95;\n\t}\n\n\t.reports-search-file-name {\n\t\tpadding: 10px;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t.reports-radio-row {\n\t\tuser-select: none;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tcolor: #142A31;\n\t\tpadding-top: 4px;\n\t}\n\n\t.reports-radio-title {\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tcolor: #6A8991;\n\t}\n\n\t.reports-search-method-row {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 350px 120px 1fr;\n\t\talign-items: center;\n\t\theight: 60px;\n\t}\n\n\t.reports-go-button {\n\t\tcursor: pointer;\n\t}\n\n\t.reports-go-button:hover {\n\t\topacity: 0.95;\n\t}\n\n\t.reports-query-container {\n\t\tdisplay: grid;\n\t\trow-gap: 10px;\n\n\t\t.reports-query-logic {\n\t\t\tpadding: 0 15px;\n\t\t\tmargin-right: 10px;\n\t\t\tuser-select: none;\n\t\t\tbackground-color: #6A8991;\n\t\t\tborder-radius: 45px;\n\t\t\tcolor: white;\n\t\t\theight: 35px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t.reports-query-button {\n\t\tbackground-color: #40A0C1;\n\t\tfont-size: 16px;\n\t\toutline: none;\n\t\tpadding: 6px 16px;\n\t\tborder-radius: 6px;\n\t\tborder: 0;\n\t\tcolor: white;\n\t\tcursor: pointer;\n\t\twhite-space: nowrap;\n\t}\n\n\t.reports-search-title {\n\t\tfont-size: 24px;\n\t\tfont-weight: 700;\n\t\tpadding-bottom: 15px;\n\t}\n\n\t.reports-info-box {\n\t\tbackground-color: #C9EBF6;\n\t\tpadding: 8px 18px 8px 8px;\n\t\tborder-radius: 5px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\twidth: fit-content;\n\t}\n\n\t.reports-methods {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 180px 1fr;\n\t\theight: 60px;\n\t}\n\n\t.reports-fields {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 180px 1fr;\n\t}\n\n\t.reports-search-bar-half {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tfont-weight: bold;\n\t\tpadding: 10px;\n\t}\n}\n\n.andOrButton {\n\tpadding: 0 15px;\n\tmargin-right: 10px;\n\tbackground-color: #6A8991;\n\tborder-radius: 45px;\n\tcolor: white;\n\theight: 35px;\n\tdisplay: flex;\n\talign-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
